import { Atom, atom } from 'jotai'
import { keyBy } from 'lodash'

export interface Department {
  id: number
  name: string
  ename: string
  parentId: number
  path: string
  leaderWechatIds: string[]
  order: number
}

export const departmentsAtom: Atom<Department[]> = atom([])

export const departmentRootId = 488797 // Agora China

export const departmentsTreeAtom = atom((get) => {
  return (get(departmentsAtom) || []).filter((d) => d.path.startsWith('1'))
})

export const departmentsMapAtom: Atom<{ [departmentId: number]: Department }> = atom((get) =>
  keyBy(get(departmentsAtom), 'id')
)
